export default "__VITE_ASSET__BoKJ9rMt__"